/* eslint-disable @typescript-eslint/no-empty-interface */
import { createTheme } from '@mui/material/styles';
import mindCode from './overrides/MuiMindCode';
import MuiTypography from './overrides/MuiTypography';

const theme = {
  palette: {
    primary: {
      main: '#3154ea',
    },
    secondary: {
      main: '#284A5E',
    },
    mind: mindCode,
  },
  text: {
    prmimary: mindCode.black.A0,
    secondary: mindCode.grey.brown,
  },
  typography: MuiTypography,
} as const;

type CustomTheme = {
  [Key in keyof typeof theme]: (typeof theme)[Key];
};

declare module '@mui/material/styles/createTheme' {
  interface Theme extends CustomTheme {}
  interface ThemeOptions extends CustomTheme {}
}

export default createTheme(theme);
